var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-dialog__footer"},[_c('span',{staticClass:"contact-dialog__footer__title"},[_vm._v(_vm._s(_vm.$t('title')))]),_vm._v(" "),_c('span',{staticClass:"contact-dialog__footer__email"},[_vm._v("hello@hemix.nl")])])}
var staticRenderFns = []

export { render, staticRenderFns }